import { render } from "./PrismaDiagram4.vue?vue&type=template&id=c05a4c86"
import script from "./PrismaDiagram4.vue?vue&type=script&lang=js"
export * from "./PrismaDiagram4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__